import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-title-divider',
  templateUrl: './title-divider.component.html',
  styleUrls: ['./title-divider.component.scss'],
})
export class TitleDividerComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() bold: boolean;
  @Input() small: boolean;

  constructor() { }

  ngOnInit() {
  }

}
